import styled, { css } from 'styled-components';
import { getSpacingToken, getToken, Stack, Typography } from '@optimus-web/core';

export const Banner = styled(Stack)<{ variant: 'banner' | 'notification' }>`
    padding: ${getSpacingToken('200')}px;
    border-radius: ${getToken('borderRadius100')}px;
    border: ${getToken('borderWidth150')}px dashed ${getToken('borderInteractiveSecondaryDefault')};
    background-color: ${getToken('backgroundStaticFlat')};
    opacity: ${getToken('opacity1000')};

    ${(props) =>
        props.variant === 'notification' &&
        css`
            border: none;
        `}
`;

export const Label = styled(Typography)`
    color: ${getToken('textAlertInfo')};
    text-transform: uppercase;
`;
